import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgWallet({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2h9a3 3 0 012.995 2.824L17 5h2a3 3 0 013 3v11a3 3 0 01-3 3H5a3 3 0 01-3-3V5l.005-.176a3 3 0 012.819-2.819L5 2h9-9zm14 5H4v12a1 1 0 001 1h14a1 1 0 001-1v-1h-3.5a4.5 4.5 0 110-9H20V8a1 1 0 00-1-1zm1 4h-3.5a2.5 2.5 0 000 5H20v-5zm-3 1.5a1 1 0 110 2 1 1 0 010-2zM14 4H5a1 1 0 00-.993.883L4 5h11l-.007-.117a1 1 0 00-.876-.876L14 4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWallet
